export default __webpack_public_path__ + "static/media/a011-5.b8e6d4fe.png";